import HeroSection from "../../Components/HeroSection";
import HowItWorksSection from "../../Components/HowItWorksSection";
import BookConsultationForm from "../../Components/BookConsultationForm";
import WhatMakesShyftBootCampUniqueSection from "../../Components/WhatMakesShyftBootCampUniqueSection";
import CallbackSection from "../../Components/CallbackSection";
import Testimonials from "@/components/Organisms/TestimonialsV2";
import RealWorldTransformation from "../../Components/RealWorldTransformation";
import AppBannerSection from "../../Components/AppBannerSection";
import AllPackagesSection from "../../Components/AllPackagesSection";
import ReadyToBuildSection from "../../Components/ReadyToBuildSection";
import FaqSection from "@/components/Molecules/FaqSection";
import FloatingBanner from "../../Components/FloatingBanner";
import BookSlotModal from "../../Components/BookSlotModal";
import CustomIntercomButton from "../../Components/CustomIntercomButton";

import CertifiedInstructors from "../../Components/Shared/CertifiedInstructors";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./IndiansLivingAbroadPage.module.scss";

interface IndiansLivingAbroadPageProps {}

const IndiansLivingAbroadPage: React.FC<IndiansLivingAbroadPageProps> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { testimonies } = data?.testimonials || {};
  const faqs = data?.faqs || {};

  return (
    <div className={cls("indiansLivingAbroadPage")}>
      <HeroSection />
      <HowItWorksSection>
        <BookConsultationForm />
      </HowItWorksSection>
      <WhatMakesShyftBootCampUniqueSection />
      <Testimonials testimonies={testimonies} />
      <CallbackSection />
      <RealWorldTransformation />
      <AllPackagesSection />
      <div className={cls("certifiedInstructors")}>
        <CertifiedInstructors />
      </div>
      <AppBannerSection />
      <FaqSection {...faqs} />
      <ReadyToBuildSection />
      <FloatingBanner />
      <BookSlotModal title={data?.bookSlotForm?.title} />
      {/* <CustomIntercomButton /> */}
    </div>
  );
};

export default IndiansLivingAbroadPage;
